import React from "react";
import cn from "classnames";
import { buttonVariants } from "theme/buttonVariants";

const HeroComponent = ({
    state: {
        url = "",
        backgroundType = "",
        heroHeading = "",
        heroHeadingColour = "text-brand-black",
        heroText = "",

        heroButtonText = "",
        heroButtonColour = "primary",
        heroButtonLink = "",
    },
    isEditMode,
    onChange,
    focused,
}) => {
    return (
        <div
            className="relative flex flex-col lg:items-start justify-end lg:justify-center p-[30px] lg:p-[60px] rounded-[10px] aspect-[355/450] sm:aspect-[1320/650]"
            style={{ backgroundColor: "#ddd" }}
        >
            <div className="flex flex-col max-w-[240px] lg:max-w-[400px] z-10 items-start">
                {heroHeading && (
                    <h1
                        className={cn(
                            `!text-[50px] !leading-[44px] lg:!text-[120px] lg:!leading-[100px] uppercase`,
                            heroHeadingColour,
                        )}
                    >
                        {heroHeading}
                    </h1>
                )}
                {heroText && (
                    <p className="uppercase text-brand-white text-[24px] lg:text-[40px] leading-[20px] lg:leading-[36px] font-extrabold">
                        {heroText}
                    </p>
                )}
                {heroButtonLink && (
                    <a
                        href={heroButtonLink}
                        className={cn(
                            buttonVariants[heroButtonColour].solidClasses,
                            "!text-brand-white !no-underline hover:text-brand-white !hover:font-bold !border-transparent !font-bold mt-[15px]",
                        )}
                    >
                        {heroButtonText}
                    </a>
                )}
            </div>

            {backgroundType === "video" && url && (
                <video
                    playsInline
                    autoPlay
                    loop
                    muted
                    src={url}
                    className="absolute top-0 left-0 w-full h-full object-cover rounded-[10px]"
                />
            )}

            {backgroundType === "image" && url && (
                <img
                    src={url}
                    className="absolute top-0 left-0 w-full h-full object-cover rounded-[10px]"
                    alt="Hero Background"
                />
            )}
        </div>
    );
};

export default HeroComponent;
